module.exports = __webpack_public_path__ + "img/gold.25a691af.png";